/* ZSportsTech — section-trust.js
   Lightbox (video) + staggered card entrance.
   Vanilla JS only, no frameworks.
   Maps to → assets/section-trust.js in Shopify theme. */
(function () {
  'use strict';

  /* ── Element refs ──────────────────────────── */
  var section   = document.getElementById('sc-trust');
  var playBtn   = document.getElementById('sc-trust-play');
  var lightbox  = document.getElementById('sc-trust-lightbox');
  var lbInner   = lightbox && lightbox.querySelector('.sc-trust__lb-inner');
  var lbClose   = document.getElementById('sc-trust-lb-close');

  /* ── DYNAMIC: set this to the actual video URL ──
     e.g. 'https://www.youtube.com/embed/VIDEO_ID?autoplay=1'
     In Shopify: '{{ section.settings.video_url | escape }}'      */
  var VIDEO_URL = 'https://www.youtube.com/embed/UELbauqcxsA?autoplay=1&rel=0'; /* DYNAMIC: section.settings.video_url */

  /* ── Lightbox open ─────────────────────────── */
  function openLightbox() {
    if (!lightbox) return;

    if (VIDEO_URL && lbInner) {
      var iframe = document.createElement('iframe');
      iframe.src = VIDEO_URL;
      iframe.allow = 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      /* Remove existing iframe if any */
      var existing = lbInner.querySelector('iframe');
      if (existing) lbInner.removeChild(existing);
      lbInner.appendChild(iframe);
    }

    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';

    /* Focus the close button */
    if (lbClose) setTimeout(function () { lbClose.focus(); }, 50);
  }

  /* ── Lightbox close ────────────────────────── */
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';

    /* Stop video */
    if (lbInner) {
      var iframe = lbInner.querySelector('iframe');
      if (iframe) lbInner.removeChild(iframe);
    }

    /* Return focus to play button */
    if (playBtn) playBtn.focus();
  }

  /* ── Event listeners ───────────────────────── */
  if (playBtn) {
    playBtn.addEventListener('click', openLightbox);
  }
  if (lbClose) {
    lbClose.addEventListener('click', closeLightbox);
  }
  if (lightbox) {
    /* Click outside inner → close */
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }

  /* Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox && !lightbox.hidden) {
      closeLightbox();
    }
  });

  /* ── Staggered card entrance on scroll ──────── */
  var mq = window.matchMedia('(prefers-reduced-motion: no-preference)');
  if (mq.matches && section && 'IntersectionObserver' in window) {
    var cards = Array.prototype.slice.call(
      section.querySelectorAll('.sc-trust__card')
    );

    /* Initially hide */
    cards.forEach(function (card) {
      card.classList.add('sc-trust--hidden');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          cards.forEach(function (card, i) {
            setTimeout(function () {
              card.classList.remove('sc-trust--hidden');
              card.classList.add('sc-trust--visible');
            }, i * 60);
          });
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    io.observe(section);
  }

}());
